var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-left":"1rem"}},[_c('div',{staticClass:"col2_head"},[_c('router-link',{staticClass:"breadcrumb_home",attrs:{"to":'/'}},[_vm._v("Acasă /")]),_vm._v(" "+_vm._s(_vm.$route.name))],1),_vm._v(" Certificate Digitale ")])
}
var staticRenderFns = []

export { render, staticRenderFns }